var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissionGroup24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_PermissionGroup24x24",
    transform: "translate(17075.508 4586.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26365",
    transform: "translate(-17075.508 -4586.5)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46766",
    d: "M-16239.524-5699.2h-1.343a2.026,2.026,0,0,0-1.975,1.738l-.158,1.58a.433.433,0,0,0,.316.474,13.052,13.052,0,0,0,2.527.237h.948l.236-1.9a3.174,3.174,0,0,1,.712-1.58A1.959,1.959,0,0,0-16239.524-5699.2Z",
    transform: "translate(16243 5710.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46767",
    d: "M-16224.377-5697.462a1.975,1.975,0,0,0-1.975-1.738h-1.343a1.887,1.887,0,0,0-1.105.4,3.044,3.044,0,0,1,.631,1.58l.237,1.974h.948a13.715,13.715,0,0,0,2.527-.236.433.433,0,0,0,.315-.474Z",
    transform: "translate(16240.141 5710.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_459",
    cx: 1.816,
    cy: 1.816,
    r: 1.816,
    transform: "translate(.948 6.466)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_460",
    cx: 1.816,
    cy: 1.816,
    r: 1.816,
    transform: "translate(11.342 6.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46768",
    d: "M-16233.035-5699.2h-1.658a2.385,2.385,0,0,0-2.369,2.054l-.237,1.974a.6.6,0,0,0,.4.553,13.6,13.6,0,0,0,3.08.316,13.614,13.614,0,0,0,3.08-.316.594.594,0,0,0,.4-.553l-.237-1.974A2.612,2.612,0,0,0-16233.035-5699.2Z",
    transform: "translate(16241.866 5710.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_461",
    cx: 2.211,
    cy: 2.211,
    r: 2.211,
    transform: "translate(5.75 5.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46769",
    d: "M-16236.154-5708.951a2,2,0,0,0,1.764-1.026h.883c.08,0,.08,0,.08-.079l.563-.553.48.553a.151.151,0,0,0,.24,0h0l.48-.553.48.553a.151.151,0,0,0,.24,0h0l.723-.711a.146.146,0,0,0,0-.236h0l-.8-.79-.082-.079h-3.447a2,2,0,0,0-1.766-1.026,2.056,2.056,0,0,0-2.086,2.054A2.384,2.384,0,0,0-16236.154-5708.951Zm-.643-2.606a.544.544,0,0,1,.561.553.544.544,0,0,1-.561.554.545.545,0,0,1-.562-.554h0a.6.6,0,0,1,.563-.553Z",
    transform: "translate(16242.035 5712.899)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissionGroup24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_PermissionGroup24x24.8e75d5c58cd558593fbd6d832c0f2c7e.svg";